import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './styles.less';

export const List: FC<ListProps> = ({ children, className }) => (
  <ul className={classNames(className, styles.list)}>{children}</ul>
);

type ListProps = {
  children?: React.ReactNode;
  className?: string;
};
